import React, { useState } from 'react';
import styles from './CourseList.module.css';

const CourseList = ({ courses, onEdit, onDelete }) => {
  const [modalCourse, setModalCourse] = useState(null);

  const formatDate = (d) => {
    if (!d) return 'N/A';
    const str = String(d).slice(0, 10);
    const [y, m, day] = str.split('-');
    return `${day}/${m}/${y}`;
  };

  const formatTime = (t) => {
    if (!t) return 'N/A';
    return String(t).slice(0, 5);
  };

  const getStatusBadge = (status) => {
    const map = {
      programmed: { text: 'Programado',  cls: styles.statusProgrammed },
      oncurse:    { text: 'En Curso',    cls: styles.statusOnCourse   },
      ended:      { text: 'Finalizado',  cls: styles.statusEnded      },
      cancel:     { text: 'Cancelado',   cls: styles.statusCancelled  },
    };
    const s = map[status] || { text: status, cls: '' };
    return <span className={`${styles.statusBadge} ${s.cls}`}>{s.text}</span>;
  };

  const handleEdit = (course) => {
    setModalCourse(null);
    onEdit(course);
  };

  const handleDelete = (id) => {
    setModalCourse(null);
    onDelete(id);
  };

  if (!courses.length) {
    return <p className={styles.noData}>No hay viajes registrados</p>;
  }

  return (
    <>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Ruta</th>
              <th>Bus</th>
              <th>Fecha</th>
              <th>Hora salida</th>
              <th>Precio</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {courses.map(course => {
              const isCancelled = course.Status === 'cancel';
              return (
                <tr key={course.ID} className={isCancelled ? styles.rowCancelled : ''}>
                  <td>{course.ID}</td>
                  <td>{course.Origin} → {course.Destination}</td>
                  <td>{course.Bus_Plate || 'N/A'}</td>
                  <td>{formatDate(course.Departure_date)}</td>
                  <td>{formatTime(course.Arrival_date)}</td>
                  <td>${course.Price || 'N/A'}</td>
                  <td>{getStatusBadge(course.Status)}</td>
                  <td>
                    <button
                      className={styles.btnActions}
                      onClick={() => setModalCourse(course)}
                      disabled={isCancelled}
                      title={isCancelled ? 'Viaje cancelado' : 'Ver acciones'}
                    >
                      {isCancelled ? 'Cancelado' : 'Acciones'}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal de acciones */}
      {modalCourse && (
        <div className={styles.modalOverlay} onClick={() => setModalCourse(null)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3 className={styles.modalTitle}>Acciones del Viaje</h3>
              <button className={styles.modalClose} onClick={() => setModalCourse(null)}>
                &times;
              </button>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.modalInfo}>
                <div className={styles.modalRow}>
                  <span className={styles.modalLabel}>ID</span>
                  <span className={styles.modalValue}>{modalCourse.ID}</span>
                </div>
                <div className={styles.modalRow}>
                  <span className={styles.modalLabel}>Ruta</span>
                  <span className={styles.modalValue}>{modalCourse.Origin} → {modalCourse.Destination}</span>
                </div>
                <div className={styles.modalRow}>
                  <span className={styles.modalLabel}>Bus</span>
                  <span className={styles.modalValue}>{modalCourse.Bus_Plate || 'N/A'}</span>
                </div>
                <div className={styles.modalRow}>
                  <span className={styles.modalLabel}>Fecha</span>
                  <span className={styles.modalValue}>{formatDate(modalCourse.Departure_date)}</span>
                </div>
                <div className={styles.modalRow}>
                  <span className={styles.modalLabel}>Hora</span>
                  <span className={styles.modalValue}>{formatTime(modalCourse.Arrival_date)}</span>
                </div>
                <div className={styles.modalRow}>
                  <span className={styles.modalLabel}>Precio</span>
                  <span className={styles.modalValue}>${modalCourse.Price}</span>
                </div>
                <div className={styles.modalRow}>
                  <span className={styles.modalLabel}>Estado</span>
                  <span className={styles.modalValue}>{getStatusBadge(modalCourse.Status)}</span>
                </div>
              </div>
            </div>

            <div className={styles.modalFooter}>
              <button
                className={styles.btnEdit}
                onClick={() => handleEdit(modalCourse)}
              >
                Editar estado
              </button>
              <button
                className={styles.btnDelete}
                onClick={() => handleDelete(modalCourse.ID)}
              >
                Cancelar viaje
              </button>
              <button
                className={styles.btnCancel}
                onClick={() => setModalCourse(null)}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CourseList;
